import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "formulario",
  class: "bg-[#434654] p-6 plex-regular"
}
const _hoisted_2 = { class: "container mx-auto max-w-7xl bg-white rounded-lg p-6" }
const _hoisted_3 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_4 = { class: "w-full px-2 md:w-1/5" }
const _hoisted_5 = { class: "text-sm text-red-500 p-error" }
const _hoisted_6 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_7 = { class: "text-sm text-red-500 p-error" }
const _hoisted_8 = { class: "w-full px-2 md:w-2/5" }
const _hoisted_9 = { class: "text-sm text-red-500 p-error" }
const _hoisted_10 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_11 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_12 = { class: "text-sm text-red-500 p-error" }
const _hoisted_13 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3"
}
const _hoisted_16 = { class: "w-full px-2" }
const _hoisted_17 = { class: "text-sm text-red-500 p-error" }
const _hoisted_18 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_19 = { class: "w-full px-2" }
const _hoisted_20 = { class: "flex flex-wrap -mx-2" }
const _hoisted_21 = { class: "w-full md:w-3/12 px-2" }
const _hoisted_22 = { class: "w-full md:w-1/12 px-2" }
const _hoisted_23 = { class: "w-full md:w-3/12 px-2" }
const _hoisted_24 = { class: "text-sm text-red-500 p-error" }
const _hoisted_25 = { class: "w-full md:w-5/12 px-2" }
const _hoisted_26 = { class: "text-sm text-red-500 p-error" }
const _hoisted_27 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_28 = { class: "w-full px-2" }
const _hoisted_29 = { class: "text-sm text-red-500 p-error" }
const _hoisted_30 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_31 = { class: "w-full px-2 md:w-1/2" }
const _hoisted_32 = { class: "text-sm text-red-500 p-error" }
const _hoisted_33 = {
  key: 0,
  class: "w-full px-2 md:w-1/2"
}
const _hoisted_34 = { class: "text-sm text-red-500 p-error" }
const _hoisted_35 = {
  key: 1,
  class: "w-full px-2 md:w-1/2"
}
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = { class: "flex flex-wrap py-2 mt-3" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_40 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "space-y-4 text-gray-700",
      onInvalidSubmit: _ctx.onInvalidSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "w-full pb-6 text-center" }, [
            _createElementVNode("h1", { class: "plex-semibold text-3xl text-gray-800" }, "ACREDITACIÓN DE PRENSA"),
            _createElementVNode("h1", { class: "plex-semibold text-gray-800" }, "Por favor complete el formulario en su totalidad")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-1" }, "DNI / Pasaporte", -1)),
              _createVNode(_component_Field, {
                name: "dni",
                modelValue: _ctx.formData.dni,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "DNI / Pasaporte",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_5, [
                    _createVNode(_component_ErrorMessage, { name: "dni" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block mb-1" }, "Nombre", -1)),
              _createVNode(_component_Field, {
                name: "nombre",
                modelValue: _ctx.formData.nombre,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Nombre",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_ErrorMessage, { name: "nombre" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-1" }, "Apellido", -1)),
              _createVNode(_component_Field, {
                name: "apellido",
                modelValue: _ctx.formData.apellido,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Apellido",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_9, [
                    _createVNode(_component_ErrorMessage, { name: "apellido" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-1" }, "Nombre del Medio", -1)),
              _createVNode(_component_Field, {
                name: "nombreMedio",
                modelValue: _ctx.formData.nombreMedio,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.nombreMedio) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "text",
                    placeholder: "Nombre del Medio",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "nombreMedio" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "block mb-1" }, "Cargo / Función", -1)),
              _createVNode(_component_Field, {
                name: "cargo",
                modelValue: _ctx.formData.cargo,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cargo) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    placeholder: "Seleccione el cargo",
                    options: _ctx.cargos,
                    optionLabel: "descripcion",
                    class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_component_ErrorMessage, { name: "cargo" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          (_ctx.formData.cargo?.id === 4)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block mb-1" }, "Especifique su cargo o función", -1)),
                  _createVNode(_component_Field, {
                    name: "otroCargo",
                    modelValue: _ctx.formData.otroCargo,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.otroCargo) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Especifique su cargo o función",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_17, [
                        _createVNode(_component_ErrorMessage, { name: "otroCargo" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block mb-1" }, "País Tel.", -1)),
                  _createVNode(_component_Select, {
                    modelValue: _ctx.selectedCountryPhone,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountryPhone) = $event)),
                    filter: "",
                    options: _ctx.paises,
                    optionLabel: "descripcion",
                    placeholder: "País",
                    class: "input-base input-success"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block mb-1" }, "Código", -1)),
                  (_ctx.selectedCountryPhone !== null)
                    ? (_openBlock(), _createBlock(_component_InputText, {
                        key: 0,
                        type: "text",
                        modelValue: _ctx.selectedCountryPhone.id,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedCountryPhone.id) = $event)),
                        class: "input-base input-success",
                        readonly: ""
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _cache[22] || (_cache[22] = _createElementVNode("label", { class: "block mb-1" }, "Cód. Área", -1)),
                  _createVNode(_component_Field, {
                    name: "codigoArea",
                    modelValue: _ctx.formData.codigoArea,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Cód. Área (sin 0)",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_24, [
                        _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[23] || (_cache[23] = _createElementVNode("label", { class: "block mb-1" }, "Tel. Celular", -1)),
                  _createVNode(_component_Field, {
                    name: "telefonoCelular",
                    modelValue: _ctx.formData.telefonoCelular,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.telefonoCelular) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Nro (sin 15)",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_26, [
                        _createVNode(_component_ErrorMessage, { name: "telefonoCelular" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block mb-1" }, "Mail", -1)),
              _createVNode(_component_Field, {
                name: "mail",
                modelValue: _ctx.formData.mail,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.mail) = $event))
              }, {
                default: _withCtx(({ field, errors }) => [
                  _createVNode(_component_InputText, _mergeProps(field, {
                    type: "mail",
                    placeholder: "Mail",
                    class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                  }), null, 16, ["class"]),
                  _createElementVNode("span", _hoisted_29, [
                    _createVNode(_component_ErrorMessage, { name: "mail" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block mb-1" }, "País (Residencia)", -1)),
              _createVNode(_component_Field, {
                name: "paisResidencia",
                modelValue: _ctx.formData.paisResidencia,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.paisResidencia) = $event))
              }, {
                default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                  _createVNode(_component_Select, {
                    filter: "",
                    onBlur: handleBlur,
                    "onUpdate:modelValue": handleChange,
                    "model-value": value,
                    class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                    placeholder: "País de residencia",
                    options: _ctx.paises,
                    optionLabel: "descripcion"
                  }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                  _createElementVNode("span", _hoisted_32, [
                    _createVNode(_component_ErrorMessage, { name: "paisResidencia" })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            (_ctx.formData.paisResidencia?.id == '+54')
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block mb-1" }, "Provincia", -1)),
                  _createVNode(_component_Field, {
                    name: "provincia",
                    modelValue: _ctx.formData.provincia,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.provincia) = $event))
                  }, {
                    default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                      _createVNode(_component_Select, {
                        onBlur: handleBlur,
                        "onUpdate:modelValue": handleChange,
                        "model-value": value,
                        placeholder: "Seleccione la provincia",
                        options: _ctx.provincias,
                        optionLabel: "descripcion",
                        class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                      }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "options", "class"]),
                      _createElementVNode("span", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "provincia" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.formData.paisResidencia?.id != '+54')
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block mb-1" }, "Provincia / Estado", -1)),
                  _createVNode(_component_Field, {
                    name: "provinciaEstado",
                    modelValue: _ctx.formData.provinciaEstado,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                  }, {
                    default: _withCtx(({ field, errors }) => [
                      _createVNode(_component_InputText, _mergeProps(field, {
                        type: "text",
                        placeholder: "Ingrese su provincia o estado",
                        class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                      }), null, 16, ["class"]),
                      _createElementVNode("span", _hoisted_36, [
                        _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("button", {
              type: "submit",
              class: "mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded",
              disabled: _ctx.isSubmitting
            }, [
              _withDirectives(_createElementVNode("i", _hoisted_39, null, 512), [
                [_vShow, _ctx.isSubmitting]
              ]),
              _withDirectives(_createElementVNode("i", _hoisted_40, null, 512), [
                [_vShow, !_ctx.isSubmitting]
              ]),
              _cache[28] || (_cache[28] = _createTextVNode("REGISTRARME ", -1))
            ], 8, _hoisted_38)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
  ]))
}